<span class="danger-badge" [matTooltip]="itemTooltip | translate"> INC {{ data?.incidentCode }} </span>
